import useSWRMutation from 'swr/mutation';
import { userService } from '../services';

export function useUserAddress() {
  const execute = async () => {
    return await userService.getUserAndAddress();
  };

  const { trigger, data, error, isMutating } = useSWRMutation(
    'get-user-address',
    execute
  );

  return {
    data,
    error,
    isLoading: isMutating,
    mutate: trigger,
  };
}
